export function checkEmail(text) {
    const pattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/; 
  
    if (pattern.test(text)) return true
    return false
}